// extracted by mini-css-extract-plugin
export default {"banner":"PermissionBanner_banner__oMUea","actions":"PermissionBanner_actions__9-1sZ"};